import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import {
  arrow_icon,
  delete_icon,
  edit_icon,
  NoImage,
  Search_icon,
} from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../components/Table/Table";
import CustomModal from "../../components/Model/Model";
import Select from "react-select";
import { Autocomplete, TextField, Chip, Alert } from "@mui/material";
import { toast } from "react-toastify";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { checkPermission } from "../redux/api/PermissionManager";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { useGlobalContext } from "../../Services/PaginationGlobal";

export default function DeleteAccount() {
    const location = useLocation();
    const path = location.pathname?.replace("/", "");
    const { paginationData, setpaginationData } = useGlobalContext();
  const [label, setLabel] = useState(paginationData?.[path]?.active ??"User");
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const [addPopup, setAddPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [type, setType] = useState();
  const [names, setNames] = useState([]);
  const [errors, setErrors] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonData, setReasonData] = useState("");
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [owners, setOwners] = useState([]);
  const [editId, setEditId] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [users, setUsers] = useState([]);

  // Get current type based on label
  const getCurrentType = () => (label === "Owner" ? 28 : 16);


  const storePaginationData = (activeTab)=>{
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], active:activeTab},
    }));
  }


  const handleDelete = async () => {
    console.log("editId--->", editId);

    if (editId) {
      try {
        setLoading(true);
        let res = await post(`${URLS.MASTERURL}${editId}/delete/`);
        if (res?.status === "success") {
          toast.success(res?.message);
        }
        setDeletePopup(false);
        setEditId(null);
        fetch(page);
      } catch (err) {
        console.error(err);
        toast.error("Failed to delete");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleOpen = () => {
    setType("add");
    setIsEdit(false);
    setAddPopup(true);
    setNames([]);
    setReason("");
    setReasonData("");
    setEditId(null);
  };

  const handleStatus = async (id) => {
    const currentType = getCurrentType();

    if (checkPermission("CAN-STATUS-DELETE_ACCOUNT")) {
      try {
        setLoading(true);
        const newStatus = !id.original?.status;
        const res = await post(`${URLS.MASTERURL}${id.original.id}/status/`, {
          status: newStatus,
          type: currentType,
        });

        if (res?.status === "success") {
          toast.success("Status updated successfully");

          // Update local state based on label
          if (label === "Owner") {
            setOwners((prevOwners) =>
              prevOwners.map((owner) =>
                owner.id === id.original.id
                  ? { ...owner, status: newStatus }
                  : owner,
              ),
            );
          } else {
            setUsers((prevUsers) =>
              prevUsers.map((user) =>
                user.id === id.original.id
                  ? { ...user, status: newStatus }
                  : user,
              ),
            );
          }
        }
      } catch (err) {
        console.error("Status update error:", err);
        toast.error("Failed to update status");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("You don't have permission to change status");
    }
  };

  const commonColumns = [
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value, row }) => (
        <div style={{ display: "flex", justifyContent: "start" }}>
          <button
            onClick={() => {
              if (checkPermission("CAN-STATUS-DELETE_ACCOUNT"))
                handleStatus(row);
            }}
            className={`${
              !value ? "deactive-btn" : "active-btn"
            } border-0  fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 `}
            disabled={loading}
          >
            {!value ? "De-active" : "Active"}
          </button>
        </div>
      ),
    },
    {
      Header: "Action",
      accessor: "",
      Cell: ({ row }) => (
        <div className="d-flex ac-js">
          {checkPermission("CAN-EDIT-DELETE_ACCOUNT") && (
            <button
              onClick={() => {
                setAddPopup(true);
                setReasonData(row.original.name);
                setEditId(row.original.id);
                setType("edit");
              }}
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
          {checkPermission("CAN-DELETE-DELETE_ACCOUNT") && (
            <button
              onClick={() => {
                setDeletePopup(true);
                setEditId(row.original.id);
              }}
              className="cust-btn"
            >
              <img src={delete_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
        </div>
      ),
    },
  ];

  const userColumns = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        const pageSize = 10;
        return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
      },
    },
    {
      Header: "Reason",
      accessor: "name",
      Cell: ({ value }) => (
        <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
      ),
    },
    ...commonColumns,
  ];

  const ownerColumns = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        const pageSize = 10;
        return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
      },
    },
    {
      Header: "Reason",
      accessor: "name",
      Cell: ({ value }) => (
        <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
      ),
    },
    ...commonColumns,
  ];

  const currentColumns =
    label === "User" ? userColumns : label === "Owner" ? ownerColumns : [];
  const currentData =
    label === "User" ? users : label === "Owner" ? owners : [];

  const handleKeyPress = (e) => {
    e.preventDefault();
    console.log("event", reason);
    if (reason && reason.trim() !== "") {
      setNames([...names, reason.trim()]);
      setReason("");
      setErrors(false);
    } else {
      setErrors(true);
    }
  };

  const fetch = async (pageNo = 1, searchQuery = search) => {
    try {
      setLoading(true);
      const currentType = getCurrentType();

      const url = searchQuery
        ? `${URLS.MASTERURL}?type=${currentType}&search=${searchQuery}&page=${pageNo}`
        : `${URLS.MASTERURL}?type=${currentType}&page=${pageNo}`;

      const res = await get(url);

      // Set data based on label
      if (label === "Owner") {
        setOwners(res?.data || []);
      } else {
        setUsers(res?.data || []);
      }

      setTotalCount(res?.total || res?.data?.length || 0);
    } catch (err) {
      console.error("Fetch error:", err);
      toast.error("Failed to fetch data");

      if (label === "Owner") {
        setOwners([]);
      } else {
        setUsers([]);
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch when label changes
  useEffect(() => {
    setPage(1);
    setSearch("");
    fetch(1, "");
  }, [label]);

  // Fetch when page changes
  useEffect(() => {
    fetch(page);
  }, [page]);

  // Debounced search
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (search !== undefined) {
        setPage(1);
        fetch(1, search);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handleSubmit = async () => {
    const currentType = getCurrentType();
    const currentData = label === "Owner" ? owners : users;

    if (type === "add") {
      // Validation: check if names array is empty
      if (names.length === 0) {
        setErrors(true);
        toast.error("Please add at least one item");
        return;
      }

      // 1. Check for names already in the list
      const existingNames = names.filter((n) =>
        currentData.some((item) => item.name === n),
      );
      if (existingNames.length > 0) {
        toast.error(`Already exists: ${existingNames.join(", ")}`);
        return;
      }

      // 2. Check for duplicates inside names itself
      const duplicateNames = names.filter((n, i) => names.indexOf(n) !== i);
      console.log("duplicateNames", duplicateNames);
      if (duplicateNames.length > 0) {
        toast.error(`Duplicates inside names: ${duplicateNames.join(", ")}`);
        return;
      }

      // 3. Check for empty strings
      const emptyNames = names.filter((n) => !n || n.trim() === "");
      if (emptyNames.length > 0) {
        toast.error("Please remove empty entries");
        return;
      }

      setLoading(true);

      try {
        // Loop through each name and send individually
        for (const name of names) {
          const formdata = new FormData();
          formdata.append("type", currentType);
          formdata.append("name", name);
          formdata.append("status", true);

          const res = await post(`${URLS.MASTERURL}add/`, formdata);
          if (res.status !== "success") {
            throw new Error(res.message || `Failed to add ${name}`);
          }
        }

        toast.success("Added successfully");
        setAddPopup(false);
        setNames([]);
        setReason("");
        setErrors(false);
        fetch(page);
      } catch (err) {
        console.error(err);
        toast.error(err.message || "Failed to add items");
      } finally {
        setLoading(false);
      }
    }

    if (type === "edit") {
      if (!reasonData || reasonData.trim() === "") {
        setErrors(true);
        toast.error("Please enter reason");
        return;
      }

      setLoading(true);

      const formdata = new FormData();
      formdata.append("type", currentType);
      formdata.append("name", reasonData);

      try {
        const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);
        if (res.status === "success") {
          toast.success(res.message || "Edited successfully");
          setEditId(null);
          setAddPopup(false);
          setReasonData("");
          setErrors(false);
          fetch(page);
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to edit item");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchClear = () => {
    setSearch("");
    setPage(1);
  };

  console.log("users", users);
  console.log("owners", owners);

  return (
    <>
      <Topbar header="Master" subHead="Delete Account" />
      <div className="d-flex ac-jf">
        <div>
          <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mb-4">
            Total: {totalCount}
          </h2>
          <div className="d-flex gap-3">
            {["User", "Owner"].map((ele) => (
              <div
                key={ele}
                style={{
                  background: label === ele ? "#6B00D8" : "none",
                  color: label === ele ? "#fff" : "#898989",
                  padding: "10px 16px",
                  borderRadius: 9,
                  fontSize: "16px",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
                onClick={() =>{
                  storePaginationData(ele)
                  setLabel(ele)}}
              >
                {ele}
              </div>
            ))}
          </div>
        </div>
        <div className="d-flex gap-3">
          <div className="search-input" style={{ position: "relative" }}>
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={handleSearchChange}
              style={{ border: "none", width: "150px", paddingRight: "30px" }}
            />
            {search && (
              <CloseSharpIcon
                onClick={handleSearchClear}
                style={{
                  position: "absolute",
                  right: "30px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  fontSize: "18px",
                }}
              />
            )}
            <img
              src={Search_icon}
              className="search pointer"
              alt="search"
              style={{ position: "absolute", right: "5px" }}
            />
          </div>
          {checkPermission("CAN-ADD-DELETE_ACCOUNT") && (
            <button onClick={handleOpen} className="add-btn white f2">
              + Add New
            </button>
          )}
        </div>
      </div>

      {loading && !addPopup && !deletePopup ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>Loading...</p>
        </div>
      ) : (
        <Table
          columns={currentColumns}
          data={currentData}
          setPageno={setPage}
        />
      )}

      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {type === "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setNames([]);
                  setReason("");
                  setReasonData("");
                  setErrors(false);
                  setEditId(null);
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div className="d-flex ac-jb mb-3">
                  <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
                    Enter Reason
                  </p>
                </div>
                {type === "add" && (
                  <div>
                    <div>
                      <div className="d-flex ae-jb input-border p-1">
                        <textarea
                          style={{ maxHeight: "80px" }}
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                          placeholder="Write Here...."
                          className="border-0 mb-3 w-80"
                        />
                        <button
                          onClick={handleKeyPress}
                          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 p-1"
                          style={{ minWidth: "100px" }}
                        >
                          Add
                        </button>
                      </div>
                      {errors && names.length === 0 && (
                        <p className="err text-start">Reason Cannot be Empty</p>
                      )}
                    </div>
                    <div>
                      {names.length > 0 ? (
                        <ul
                          className="input-border overflow-scroll mt-2"
                          style={{ minHeight: "50px", maxHeight: "200px" }}
                        >
                          {names?.map((name, index) => {
                            return (
                              <li
                                className="d-flex as-js gap-3 mt-2"
                                key={index}
                              >
                                <img
                                  src={arrow_icon}
                                  className="bullet-btn"
                                  alt=""
                                />
                                <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                                  {name}
                                </p>
                                <img
                                  src={delete_icon}
                                  className="delete-btn pointer"
                                  onClick={() => {
                                    const updatedNames = names.filter(
                                      (_, i) => i !== index,
                                    );
                                    setNames(updatedNames);
                                  }}
                                  alt="delete"
                                />
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                {type === "edit" && (
                  <div>
                    <input
                      type="text"
                      value={reasonData}
                      onChange={(e) => {
                        setReasonData(e.target.value);
                      }}
                      placeholder="Reason here"
                      className="input-box"
                    />
                    {errors && (
                      <p className="err text-start">Reason Cannot be Empty</p>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex ac-je px-2 mt-4">
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="submit-btn f2 w-20 p-2 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15"
              >
                {loading ? "Loading..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
      {deletePopup && (
        <CustomModal
          open={deletePopup}
          noCancelBtn
          onConfirm={handleDelete}
          title="Are you sure you want to Delete?"
          paddingDelete={10}
        >
          <div className="d-flex" style={{ justifyContent: "space-between" }}>
            <button
              style={{
                border: "1px solid #707070",
                padding: "10px 15px",
                minWidth: "40%",
                borderRadius: 5,
                background: "none",
              }}
              className="back-btn mt-3"
              onClick={() => {
                setDeletePopup(false);
                setEditId(null);
              }}
            >
              No
            </button>
            <button
              style={{
                backgroundColor: "#5A8DFF",
                border: 0,
                padding: "10px 15px",
                minWidth: "40%",
                borderRadius: 5,
                color: "#fff",
              }}
              className="submit-btn mt-3"
              onClick={handleDelete}
              disabled={loading}
            >
              {loading ? "Deleting..." : "Yes"}
            </button>
          </div>
        </CustomModal>
      )}
    </>
  );
}
